<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="DEMO PANEL" key="1">
        <a-card>
          Contenido del panel
        </a-card>
      </a-tab-pane>
    </a-tabs>

    <br/>

    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="DEMO MULTIPLES PANELES" key="1" style="border: 1px solid #e8e8e8; padding: 24px 32px">
        CONTENIDO
      </a-tab-pane>
      <a-tab-pane tab="DEMO MULTIPLES PANELES" key="2" style="border: 1px solid #e8e8e8; padding: 24px 32px">
        CONTENIDO
      </a-tab-pane>
      <a-tab-pane tab="DEMO MULTIPLES PANELES" key="3" style="border: 1px solid #e8e8e8; padding: 24px 32px">
        CONTENIDO
      </a-tab-pane>
    </a-tabs>

    <a-divider>PROPUESTA DE CONSULTA</a-divider>

    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="CONSULTA DE ACUMULADOS" key="1">
        <a-collapse v-model="activeKey2" accordion>
          <a-collapse-panel header="Nómina Abierta" key="1">
            <p>Contenido</p>
          </a-collapse-panel>
          <a-collapse-panel header="Nómina Cerrada" key="2" :disabled="false">
            <p>Contenido</p>
          </a-collapse-panel>
        </a-collapse>
      </a-tab-pane>
      <a-tab-pane tab="CONSULTA DE ACUMULADOS PROPUESTA" key="2">
        <a-card>
          <a-radio-group :options="['Abierta', 'Cerrada']"/>
        </a-card>
      </a-tab-pane>
    </a-tabs>

    <a-divider>COMPONENTES GRAFICOS</a-divider>

    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="LISTAS DE VALORES" key="1">
        <a-card>
          <a-form :form="form">
            <a-row>
              <a-col :span="12">
                <g-select :options="[{value: 1, text:'Opción 1'},{value: 2, text:'Opción 2'},{value: 3, text:'Opción 3'}
                                ,{value: 4, text:'Opción 4'}
                                ,{value: 5, text:'Opción 5'}
                                ,{value: 6, text:'Opción 6'}]" :selectedObj.sync="select"
                          :formItemConfig="{ label:'Select estático' }"></g-select>
              </a-col>
              <a-col :span="12">
                {{select}}
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <g-dropdown endpoint="hierarchy_lookup" :selectedObj.sync="dropdown"
                            :formItemConfig="{ label:'Lista de valores' }"
                            :params="dropDownParams"></g-dropdown>
              </a-col>
              <a-col :span="12">
                {{dropdown}}
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="6">
                <g-dropdown endpoint="hierarchy_lookup" :selectedObj.sync="localizacion.pais"
                            :formItemConfig="{ label:'Pais' }"
                            :params="paisParams"></g-dropdown>
              </a-col>
              <a-col :span="6">
                <g-dropdown endpoint="hierarchy_lookup" :selectedObj.sync="localizacion.departamento"
                            :formItemConfig="{ label:'Departamento' }"
                            :params="deptoParams"></g-dropdown>
              </a-col>
              <a-col :span="6">
                <g-dropdown endpoint="hierarchy_lookup" :selectedObj.sync="localizacion.ciudad"
                            :formItemConfig="{ label:'Ciudades' }"
                            :params="ciudadParams"></g-dropdown>
              </a-col>
              <a-col :span="6">{{localizacion}}</a-col>
            </a-row>
            <a-row>
              <a-col :span="6">
                <g-lookup endpoint="hierarchy_lookup" :selectedObj.sync="localizacion.pais"
                          :formItemConfig="{ label:'Pais' }"
                          :params="paisParams" :decorator="paisConfig.decorator"></g-lookup>
              </a-col>
              <a-col :span="6">
                <g-lookup endpoint="hierarchy_lookup" :selectedObj.sync="localizacion.departamento"
                          :formItemConfig="{ label:'Departamento' }"
                          :params="depto2Params"></g-lookup>
              </a-col>
              <a-col :span="6">
                <g-lookup endpoint="hierarchy_lookup" :selectedObj.sync="localizacion.ciudad"
                          :formItemConfig="{ label:'Ciudades' }"
                          :params="ciudad2Params"></g-lookup>
              </a-col>
            </a-row>
          </a-form>
        </a-card>
      </a-tab-pane>
      <a-tab-pane tab="DATATABLES" key="2">
        <a-card>
          <g-datatable :columns="datatable.columns" endpoint="hierarchy_lookup"
                       :tableConfig="datatable.config"></g-datatable>
        </a-card>
      </a-tab-pane>
      <a-tab-pane tab="SELECCIONABLE DATATABLES" key="3">
        <a-card>
          <g-datatable :columns="datatable.columns" endpoint="hierarchy_lookup"
                       :tableConfig="datatable.config"
                       :allowSelect="true"
                       selectType="radio"
                       :selectedRowKeys.sync="datatable.selectedKeys1"
                       :selectedRows.sync="datatable.selectedRows1"
          ></g-datatable>
          <a-card>
            {{datatable.selectedKeys1}}
            {{datatable.selectedRows1}}
          </a-card>
        </a-card>
      </a-tab-pane>
      <a-tab-pane tab="SELECCIONABLE DATATABLES MULTIPLE" key="4">
        <a-card>
          <g-datatable :columns="datatable.columns" endpoint="hierarchy_lookup"
                       :tableConfig="datatable.config"
                       :allowSelect="true"
                       selectType="checkbox"
                       :selectedRowKeys.sync="datatable.selectedKeys2"
                       :selectedRows.sync="datatable.selectedRows2"
          ></g-datatable>
          <a-card>
            {{datatable.selectedKeys2}}
            {{datatable.selectedRows2}}
          </a-card>
        </a-card>
      </a-tab-pane>
    </a-tabs>

    <a-divider>MAESTRO</a-divider>

    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="MAESTRO" key="1">
        <g-master endpoint="hierarchy_lookup"
                  :tableSetup="masterTableSetup" name="tmpmaster">
          <template slot="masterModal" slot-scope="{record}">
            <span>Hola mundo modal!!</span>
            <span>{{record}}</span>
            <a-row :gutter="24">
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" label="Descripción">
                  <a-input v-decorator="['description']"/>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>

  </div>
</template>
<script>
  export default {
    data () {
      return {
        form: this.$form.createForm(this, {
          name: 'demo',
          onFieldsChange: (_, changedFields) => {
            console.log('campo cambiado', changedFields)
          }
        }),
        activeKey: [1, 2],
        activeKey2: [1],
        select: {},
        dropdown: {},
        localizacion: {
          pais: {},
          departamento: {},
          ciudad: {}
        },
        paisConfig: {
          decorator: ['pais', {rules: [{required: true, message: 'Vlaor Requerido'}]}]
        },
        datatable: {
          columns: [
            {title: 'Código', dataIndex: 'id_h_lookup', sorter: true, width: 120},
            {title: 'Descripción', dataIndex: 'description', sorter: true}
          ],
          config: {
            scroll: {y: 400},
            rowKey: 'id_h_lookup'
          },
          selectedKeys1: [],
          selectedRows1: [],
          selectedKeys2: [],
          selectedRows2: []
        },
        masterTableSetup: {
          columns: [
            {title: 'Código', dataIndex: 'id_h_lookup', sorter: true, width: 120},
            {title: 'Descripción', dataIndex: 'description', sorter: true}
          ],
          tableConfig: {
            scroll: {x: 720, y: 400},
            rowKey: 'id_h_lookup'
          },
          allowSelect: true,
          selectedKeys: []
          /* actions: {
            title: 'Acciones',
            scopedSlots: {customRender: 'action'},
            width: 120,
            fixed: 'right',
            actions: [{
              name: 'editar', text: 'Editar', icon: 'edit',
            }]
          } */
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 6},
          'wrapper-col': {span: 18},
          'has-feedback': true
        }
      }
    },
    computed: {
      dropDownParams () {
        return {id_h_lookup_type: 2}
      },
      paisParams () {
        return {h_lookup_type: 'PAISES'}
      },
      deptoParams () {
        return {h_lookup_type: 'DEPARTAMENTOS', id_h_lookup_father: this.localizacion.pais.value}
      },
      depto2Params () {
        return {h_lookup_type: 'DEPARTAMENTOS', id_h_lookup_father: this.localizacion.pais.value}
      },
      ciudadParams () {
        return {h_lookup_type: 'CIUDADES', id_h_lookup_father: this.localizacion.departamento.value}
      },
      ciudad2Params () {
        return {h_lookup_type: 'CIUDADES', id_h_lookup_father: this.localizacion.departamento.value}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/ComponentsDemo/ComponentsDemo.vue